<div class="datatable">
  <div class="table-wrapper">
    <table [ngClass]="getStatusClass()" aria-describedby="patients table">
      <thead *ngIf="showHeader">
        <tr>
          <th *ngFor="let column of columns" [ngClass]="column.orderable ? 'orderable' : ''"
            (click)="changeSorting(column.field)">
            <div class="th-content">
              <span>{{ column.label }}</span>
              <span *ngIf="column.orderable" [ngClass]="sorting[column.field]">
                <mat-icon>arrow_drop_up</mat-icon>
                <mat-icon>arrow_drop_down</mat-icon>
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paginationProps.filteredItems; let indexItem = index">
          <td *ngFor="let column of columns; let i = index">
            <div *ngIf="column.field !== 'no'">
              <div *ngIf="column.type === 'template'; then isTemplate; else fallback"></div>
              <ng-template #isTemplate>
                <ng-content
                  *ngTemplateOutlet="cellTemplatesMap[column.field]; context: { item: item, data: column, i: indexItem }">
                </ng-content>
              </ng-template>
              <ng-template #fallback>
                {{ (column.format && column.format(item)) || transformValue(item, column.field) || '---' }}
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator *ngIf="displayPagination" [length]="paginationProps.totalItems" [pageSize]="paginationProps.pageSize"
    [pageIndex]="paginationProps.pageNumber" [pageSizeOptions]="[10, 25, 50, 75, 100]" (page)="pageChange($event)">
  </mat-paginator>
</div>